export default __webpack_public_path__ + "wordpress.fd20e8b8.png";